import { render, staticRenderFns } from "./AllAuctionsOnCategoriesPieChart.vue?vue&type=template&id=464ebee0&scoped=true&"
import script from "./AllAuctionsOnCategoriesPieChart.vue?vue&type=script&lang=js&"
export * from "./AllAuctionsOnCategoriesPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464ebee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
